import Rest from '@/services/Rest';

export default class HomeService extends Rest {
  static resource = 'home';

  getEmptyState() {
    return this.get('empty-state/get');
  }

  disableEmptyState(key: string) {
    return this.post('empty-state/disableEmptyState', { key });
  }

  saveTourGuideStatus(completed: boolean) {
    return this.post('tour-guide/disableTourGuideStatus', { key: 'tour-guide', value: completed });
  }

  getTourGuideStatus() {
    return this.get('tour-guide/get');
  }
}
